const inputHeight = {
  xs: '1rem',
  s: '1.25rem',
  m: '1.5rem',
  l: '2.25rem',
}

export default inputHeight



// WEBPACK FOOTER //
// ./src/global/forms.js